import React, { useEffect } from 'react';

const queryString = require('query-string');

const CardpointeIFrame = (props) => {
  const { handlePayment, ...queryProps } = props;
  const queryParams = queryString.stringify(queryProps);

  const css = `label{font-family: Sans-serif; color: ##262d3f;}
        *{margin-left: 10px}
        .error{color: red;}
        select{margin: 6px 0px; padding: 5px;width:95px; font-size: 1.2rem;border-radius: 4px; outline: 1px solid; border: 4px solid transparent;}
        select:focus{border-radius: 4px; border: 4px solid #037bb5;outline: none}
        input{padding: 5px;width:200px;font-size: 1.2rem;margin: 6px 0px;border-radius: 4px; outline: 1px solid; border: 4px solid transparent;}
        input:focus{border-radius: 4px; border: 4px solid #037bb5;outline: none}
        br{height: 6px;}`;
  const encodedCss = encodeURIComponent(css);

  const CARDPOINTE_BASE_URL = 'https://fts-uat.cardconnect.com';
  const CARDPOINTE_IFRAME_API = `${CARDPOINTE_BASE_URL}/itoke/ajax-tokenizer.html?${queryParams}&css=${encodedCss}`;

  const handleCardEvent = (event) => {
    if (event.origin !== CARDPOINTE_BASE_URL) {
      return;
    }
    try {
      const token = event && event.data && JSON.parse(event.data);
      if (token) {
        handlePayment(token);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleCardEvent, false);
    return () => {
      window.removeEventListener('message', handleCardEvent);
    };
  }, []);

  return (
    <form name='tokenform' id='tokenform'>
      <iframe
        style={ { height: '235px' } }
        title='card-pointe'
        id='tokenFrame'
        name='tokenFrame'
        src={ CARDPOINTE_IFRAME_API }
        frameBorder='0'
        scrolling='no'
      />
    </form>
  );
};

export default CardpointeIFrame;
